@if (
	{
		hasVideo: !!videoId,
	};
	as vm
) {
	<ng-container *clientScreen="let isDesktop = isDesktop">
		<div class="legacy-wrapper" [class.desktop]="isDesktop">
			<div class="section">
				<div
					class="image relative"
					[class.cursor-pointer]="vm.hasVideo"
					(click)="vm.hasVideo ? openVideo() : null"
				>
					<ng-content select="img, [img]"></ng-content>
					@if (vm.hasVideo) {
						<div
							class="p-1 rounded-circle flex absolute top-1/2 left-1/2 [background-color:rgba(0,_0,_0,_0.5)] [transform:translate(-50%,_-50%)]"
						>
							<i class="icon-play-circle fc-white"></i>
						</div>
					}
				</div>
			</div>
			<div
				class="section"
				[class.scrollbar-fade]="isDesktop"
				[class.overflow-auto]="isDesktop"
			>
				<div class="title">
					<ng-content select="[title]"></ng-content>
				</div>
				<div class="message">
					<ng-content></ng-content>
				</div>
			</div>
		</div>
	</ng-container>
}
